var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sticky-header-layout',[_c('search-panel',{attrs:{"is-loading":_vm.isLoading},on:{"search":_vm.handleSearch,"generateCSV":_vm.handleGenerateCSV}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }